import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const qualificationService = {
  fetchQualificationByCandidateID: (id) => {
    return axiosInstance.get(
      `/itl_qualifications?$select=itl_address,_itl_candidateid_value,itl_classdivision,itl_institutename,itl_marksobtained,itl_name,itl_year&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addQualification: (obj) => {
    return axiosInstance.post(`/itl_qualifications`, obj, {
      headers: headers,
    });
  },

  updateQualification: (id, obj) => {
    return axiosInstance.patch(`/itl_qualifications(${id})`, obj, {
      headers: headers,
    });
  },

  deleteQualification: (id) => {
    return axiosInstance.delete(`/itl_qualifications(${id})`, {
      headers: headers,
    });
  },
};

export default qualificationService;
